module.exports = __webpack_public_path__ + "static/play-icon-mint-231a78b834039cee20c7908bc4102b57.png";